<template>
    <div>
        <Hero :image="hero" :claim="``" :styleObject="styleObject" />
        <header class="header frame-h-medium">
            <span class="header__svg" :style="{ 'background-image': `url(${logo})` }" alt=""></span>
            <LanguageSwitch
                class="header__languages"
                :languages="languages"
                :language="language"
                @select="select" />
        </header>


    </div>
</template>

<script>
    export default {
        name: "InfoHeader",
        props: {
            logo: String,
            hero: String,
            select: Function,
            language: String,
            languages: Object
        },
        data() {
            return {
                styleObject: {
                    position: "absolute"
                }
            }
        }
    }
</script>

<style scoped>

</style>
